import { renderToolBlockInstance } from "../../shared/SimulatorWrapper/SimulatorWrapper";
import { forms } from "./Form/Form";
import Results from "./Results/Results";

// Define the tool key this view handles
const TOOL_KEY = "quote_payment";

// Call the wrapper with tool-specific components and form config
renderToolBlockInstance({
  toolKey: TOOL_KEY,
  formConfig: forms[TOOL_KEY],
  Results,
});
